import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">关于樱花动漫91平台使用的常见疑问解答</p>
          </div>

          <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {faqItems.map((faq) => (
              <div
                key={faq.id}
                className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70"
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2">
                  {faq.question}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}